// Money/percentage helpers using integer paise arithmetic to avoid float errors

export function sanitizePercentInput(input) {
  try {
    if (input === null || input === undefined) return 0;
    const s = String(input).trim();
    const cleaned = s.endsWith('%') ? s.slice(0, -1) : s;
    const n = parseFloat(cleaned);
    return Number.isFinite(n) ? n : 0;
  } catch {
    return 0;
  }
}

export function rupeesToPaise(value) {
  const n = typeof value === 'string' ? parseFloat(value) : Number(value);
  const safe = Number.isFinite(n) ? n : 0;
  return Math.round(safe * 100);
}

export function paiseToRupees(paise) {
  const p = Number.isFinite(paise) ? paise : 0;
  return p / 100;
}

export function formatTwoDecimals(value) {
  const n = typeof value === 'string' ? parseFloat(value) : Number(value);
  const safe = Number.isFinite(n) ? n : 0;
  return safe.toFixed(2);
}

// Core calculation per spec
// Inputs in rupees; percents as user-entered (number or string with %)
// Calculation flow: Fuel charges calculated first, then royalty charges calculated on base + fuel charges
export function computeInvoiceCharges({
  consignmentAmount,
  odaCharges,
  docketCharges,
  otherCharges,
  fuelPercent,
  royaltyPercent,
}) {
  // Base amount = consignment + all other charges
  const basePaise =
    rupeesToPaise(consignmentAmount) +
    rupeesToPaise(odaCharges) +
    rupeesToPaise(docketCharges) +
    rupeesToPaise(otherCharges);

  const fuelPct = sanitizePercentInput(fuelPercent);
  const royaltyPct = sanitizePercentInput(royaltyPercent);

  // Step 1: Calculate fuel charges on the base amount
  const fuelAmountPaise = Math.round((basePaise * fuelPct) / 100);
  
  // Step 2: Calculate royalty charges on (base + fuel charges)
  const baseWithFuelPaise = basePaise + fuelAmountPaise;
  const royaltyAmountPaise = Math.round((baseWithFuelPaise * royaltyPct) / 100);

  const taxableValuePaise = basePaise + fuelAmountPaise + royaltyAmountPaise;

  return {
    basePaise,
    fuelAmountPaise,
    royaltyAmountPaise,
    taxableValuePaise,
    baseRupees: paiseToRupees(basePaise),
    fuelAmountRupees: paiseToRupees(fuelAmountPaise),
    royaltyAmountRupees: paiseToRupees(royaltyAmountPaise),
    taxableValueRupees: paiseToRupees(taxableValuePaise),
    fuelPercentOriginal: fuelPercent,
    royaltyPercentOriginal: royaltyPercent,
  };
}


